import React from "react";
import { classNames } from "primereact/utils";
import classes from "./TableText.module.css";
const TableValue = ({ top, down }) => {
  return (
    <div>
      <p className={classNames(classes.text, classes.bold)}>{top}</p>
      {down && (
        <p className={classNames(classes.text, classes.light)}>{down}</p>
      )}
    </div>
  );
};

export default TableValue;
